import React, { useEffect, useState } from 'react'
import { useAuth } from '../../../../auth/auth'
import { getJobVersionHistory } from '../../../../api/apiCall';
import { useLocation } from "react-router-dom";
import { format } from 'date-fns';
import styles from './VersionHistory.module.css';
import {
  getFatigue,
  getHotelStatus,
  getHStatus,
  getShiftStatus,
  getSStatus,
  getTStatus,
} from "../../../../utils/statusUtils";

const VersionHistroy = () => {
  const {state} = useAuth();
  const location = useLocation();
  const [history, setHistory] = useState<any>([])
  const { id } = location.state || {};

  const valueFormatters: any = {
    t: getTStatus,
    s: getSStatus,
    h_Color: getHStatus,
    jobType: getHotelStatus,
    fatigueStatus: getFatigue,
    jobStatus: getShiftStatus,
    hotelStatus: getHotelStatus,
  };

  const getHistory = async () => {
    const response = await getJobVersionHistory(state.user?.token, id);
    setHistory(response)
  };

  useEffect(() => {
    getHistory();
  }, []);

  const transformedData = history.map((history: any) => ({
    createdDate: history.createdDate,
    jobId: history.jobId,
    updatedByUser: history.updatedByUser,
    changes: history.changes.filter((change: any) => change.property !== "userId")
  }));

  return (
    <div className={styles.versionContainer}>
      <header className={styles.headerLogger}>
        <h1>Version History
          <h4 className={styles.ukTime}>UK TIME ZONE</h4>
        </h1>
      </header>
      <table className={styles.versionHistoryTable}>
        <thead>
          <tr>
            <th style={{padding: 20}}>Modified</th>
            <th>Property</th>
            <th>New Value</th>
            <th>Old Value</th>
            <th>Modified By</th>
          </tr>
        </thead>
        <tbody style={{marginTop: 20}}>
          {transformedData.length > 0 ? (
            transformedData.map((worker: any) => (
              worker.changes.map((change: any, index: number) => (
                <tr key={`${worker.jobId}-${index}`} style={{backgroundColor: '#f5f5f5'}}>
                  {index === 0 && (
                    <td rowSpan={worker.changes.length} style={{ backgroundColor: '#F5f5f5', borderBottom: '3px solid lightgray' }}>
                      {format(new Date(worker.createdDate), "do MMM, HH:mm")}
                    </td>
                  )}
                  <td style={{ borderBottom: worker.changes.length - 1 === index ? '3px solid lightgray': 'none', padding: 20 }}>
                    {change.property}
                  </td>
                  <td style={{ borderBottom: worker.changes.length - 1 === index ? '3px solid lightgray': 'none' }}>
                    {valueFormatters[change.property]
                      ? valueFormatters[change.property](Number(change.newValue))
                      : change.property === 'endTime' || change.property === 'startTime' ? format(change.newValue, 'HH:mm') : change.newValue
                    }
                  </td>
                  <td style={{ borderBottom: worker.changes.length - 1 === index ? '3px solid lightgray': 'none' }}>
                    {valueFormatters[change.property]
                      ? valueFormatters[change.property](Number(change.oldValue))
                      : change.property === 'endTime' || change.property === 'startTime' ? format(change.oldValue, 'HH:mm') : change.oldValue
                    }
                  </td>
                  {index === 0 && (
                    <td rowSpan={worker.changes.length} style={{ backgroundColor: '#F5f5f5', borderBottom: '3px solid lightgray' }}>{worker.updatedByUser}</td>
                  )}
                </tr>
              ))
            ))
          ) : (
            <tr>
              <td colSpan={5} className="table-data center-align">
                No records.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default VersionHistroy;
